<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item
          label="指令名字"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            v-decorator="[
              'name',
              { rules: [{ required: true, message: '请输入指令名字' }] }
            ]"
            placeholder="请输入指令名字"
          ></a-input>
        </a-form-item>
        <a-form-item
          label="事件指令"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            v-decorator="[
              'eventCommand',
              { rules: [{ required: true, message: '请输入事件指令' }] }
            ]"
            placeholder="请输入事件指令"
          ></a-input>
        </a-form-item>
        <a-form-item label="状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-switch
            checked-children="启用"
            un-checked-children="未启用"
            v-model="model.status"
          />
        </a-form-item>
        <a-form-item
          label="处理类型"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select
            v-decorator="[
              'handleType',
              { rules: [{ required: true, message: '请选择处理类型' }] }
            ]"
            placeholder="请选择处理类型"
            @change="handleType"
          >
            <a-select-option :value="'text'" :key="1">文本</a-select-option>
            <a-select-option :value="'image'" :key="2">图片</a-select-option>
            <a-select-option :value="'voice'" :key="3">语音</a-select-option>
            <a-select-option :value="'video'" :key="4">视频</a-select-option>
            <a-select-option :value="'music'" :key="5">音乐</a-select-option>
            <a-select-option :value="'news'" :key="6">图文</a-select-option>
            <a-select-option :value="'other'" :key="7">其他</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          label="处理内容"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-textarea
            v-decorator="[
              'handleContent',
              { rules: [{ required: true, message: '请输入事件指令' }] }
            ]"
            :placeholder="handleContentPlaceholder"
          ></a-textarea>
        </a-form-item>
      </a-form>
    </a-spin>
  </j-modal>
</template>

<script>
import { httpAction } from '@/api/manage';
import pick from 'lodash.pick';
import { validateDuplicateValue } from '@/utils/util';
import JDate from '@/components/jeecg/JDate';

export default {
  name: 'EventCommandModal',
  components: {
    JDate
  },
  data() {
    return {
      form: this.$form.createForm(this),
      title: '操作',
      appId: '',
      width: 800,
      visible: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      confirmLoading: false,
      validatorRules: {},
      url: {
        add: process.env.VUE_APP_CMS_WECHAT + '/eventCommand/add',
        edit: process.env.VUE_APP_CMS_WECHAT + '/eventCommand/edit'
      },
      handleContentPlaceholder: ''
    };
  },
  created() {},
  methods: {
    add() {
      this.edit({});
    },
    edit(record) {
      this.form.resetFields();
      this.model = Object.assign({}, record);
      if (this.model.status == 1) {
        this.model.status = true;
      } else {
        this.model.status = false;
      }
      this.visible = true;
      this.$nextTick(() => {
        this.form.setFieldsValue(
          pick(
            this.model,
            'name',
            'eventCommand',
            'handleType',
            'appId',
            'handleContent'
          )
        );
      });
    },
    close() {
      this.$emit('close');
      this.visible = false;
    },
    handleOk() {
      const that = this;
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true;
          let httpurl = '';
          let method = '';
          if (!this.model.id) {
            httpurl += this.url.add;
            method = 'post';
          } else {
            httpurl += this.url.edit;
            method = 'post';
          }
          let formData = Object.assign(this.model, values);
          if (this.appId) {
            formData.appId = this.appId;
          }
          formData.createTime = '';
          formData.createBy = '';
          formData.delFlag = '';
          if (formData.status) {
            formData.status = '1';
          } else {
            formData.status = '0';
          }
          console.log('表单提交数据', formData);
          httpAction(httpurl, formData, method)
            .then(res => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.warning(res.message);
              }
            })
            .finally(() => {
              that.confirmLoading = false;
              that.close();
            });
        }
      });
    },
    handleCancel() {
      this.close();
    },
    popupCallback(row) {
      this.form.setFieldsValue(
        pick(
          row,
          'name',
          'eventCommand',
          'handleType',
          'appId',
          'handleContent'
        )
      );
    },
    handleType(val) {
      this.model.handleContent = '';
      if (val === 'text') {
        this.handleContentPlaceholder = '一段文本，支持a标签';
      } else if (val === 'image') {
        this.handleContentPlaceholder = '素材ID';
        this.model.handleContent = '{"MediaId": ""}';
      } else if (val === 'voice') {
        this.handleContentPlaceholder = '素材ID';
        this.model.handleContent = '{"MediaId": ""}';
      } else if (val === 'video') {
        this.handleContentPlaceholder = '素材ID';
        this.model.handleContent =
          '{"MediaId": "", \n"Title": "", \n"Description": ""}';
      } else if (val === 'music') {
        this.handleContentPlaceholder = '素材ID';
        this.model.handleContent =
          '{"Title": "", \n"Description": "", \n"MusicUrl": "", \n"HQMusicUrl": "", \n"ThumbMediaId": ""}';
      } else if (val === 'news') {
        this.model.handleContent = '{"ArticleId": "", \n"Url": ""}';
      } else if (val === 'other') {
        this.handleContentPlaceholder = '执行Bean的名字';
      }
      this.form.setFieldsValue(pick(this.model, 'handleContent'));
    }
  }
};
</script>
